import LoadMoreInstances from "../utils/LoadMoreInstances.js";

class EventInstancesFilter {
    constructor(el) {
        this.instancesFilter = el;

        this.form = this.instancesFilter?.querySelector(`form`);

        this.initialInstances = document.querySelector(`[data-instances-list]`);

        this.initialInstancesClone = this.initialInstances.cloneNode(true);

        this.instancesContainer = this.initialInstances;

        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);

        this.loadMoreBtn = document.getElementById("load-more-btn");

        this.howManyInstancesLabel = document.querySelector(
            `[data-instances-current-shown]`,
        );

        this.init();
    }

    init() {
        this.initFilters();
        this.initAllItems();
        this.createAccessTagsMap();
    }

    initFilters() {
        this.checkBoxes = this.form?.querySelectorAll(`input[type="checkbox"]`);

        this.checkBoxes?.forEach((checkbox) => {
            checkbox.addEventListener("change", this.handleCheckboxChange);
        });
    }

    handleCheckboxChange() {
        const selectedTags = Array.from(this.checkBoxes)
            .filter((checkbox) => checkbox.checked)
            .map((checkbox) => checkbox.id);

        if (selectedTags.length) {
            this.filteredInstances = this.filterInstancesByAccess(selectedTags);

            this.displayMatchingInstances();
        } else {
            // location.reload(); <-- much more straighaway action.
            // The below code has to be implemented because of
            // https://app.clickup.com/t/8698pwur5?comment=90120120597934

            this.instancesContainer.innerHTML = "";

            // Reinstate the original status of the instances.
            this.instancesContainer.appendChild(
                this.initialInstancesClone.cloneNode(true),
            );

            // Run the init functions again.
            this.initAllItems();
            this.createAccessTagsMap();
            this.updateHowManyInstancesShown(8);

            if (this.loadMoreBtn) {
                // Clone loadMore Btn, so the previous click event attached is removed.
                const loadMoreClone = this.loadMoreBtn.cloneNode(true);
                this.loadMoreBtn.parentNode.replaceChild(
                    loadMoreClone,
                    this.loadMoreBtn,
                );

                // Update reference to the new Load more
                this.loadMoreBtn = loadMoreClone;
                this.loadMoreBtn.setAttribute("data-page-num", 1);

                const loadMoreBtns = document.querySelectorAll(
                    "[data-load-more-btn]",
                );

                // Reload the LoadMoreInstances component
                if (loadMoreBtns.length) {
                    loadMoreBtns.forEach((button) => {
                        new LoadMoreInstances(button);
                    });
                }

                this.loadMoreBtn.style.display = "block";
            }
        }
    }

    displayMatchingInstances() {
        if (this.filteredInstances.length) {
            this.updateHowManyInstancesShown(this.filteredInstances.length);

            this.instancesContainer.innerHTML = "";

            if (this.loadMoreBtn) {
                this.loadMoreBtn.style.display = "none";
            }

            this.allInstances?.forEach((instance) => {
                if (this.filteredInstances.includes(instance.id)) {
                    instance.classList?.remove("hidden");

                    this.instancesContainer.appendChild(instance);
                }
            });
        }
    }

    initAllItems() {
        this.allInstances =
            this.initialInstances.querySelectorAll(`li.event-instance`);
    }

    createAccessTagsMap() {
        let mapData = [];

        this.allInstances?.forEach((instance) => {
            const accessUl = instance.querySelector(`[data-json-access-tags]`);

            const accessData = accessUl.dataset?.jsonAccessTags;

            const parsedArr = JSON.parse(accessData);

            let tagsSet = new Set(parsedArr);

            let mapSetItem = [instance.id, tagsSet];

            mapData.push(mapSetItem);
        });

        this.allInstancesAccessMap = new Map(mapData);
    }

    filterInstancesByAccess(selTags) {
        console.log(selTags);

        if (!selTags.length) {
            return [];
        }

        let results = [];

        selTags?.forEach((searchTerm) => {
            this.allInstancesAccessMap.forEach((instance, key) => {
                if (instance.has(searchTerm)) {
                    results.push(key);
                }
            });
        });

        // Unique results
        results = [...new Set(results)];

        return results;
    }

    updateHowManyInstancesShown(howMany) {
        if (this.howManyInstancesLabel && howMany > 0) {
            this.howManyInstancesLabel.textContent = howMany.toString();
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const instancesFilter = document.querySelector(`[data-instances-filter]`);

    if (instancesFilter) {
        new EventInstancesFilter(instancesFilter);
    }
});
